export default __webpack_public_path__ + "static/media/musicNote.9e4da5e4.png";